import PostTiles from "../../../../shared/components/blog/PostTiles";
import { getAllPostsForHome } from "../../../../shared/lib/api";
import {
  BlogContentGrid,
  BlogContentSection,
  TileSizes,
} from "../../../../shared/styles/blog/blog";
import {
  Container,
  ContainerContentNarrow,
} from "../../../../shared/styles/container";
import Layout from "../../components/global/Layout";
import Seo from "../../components/global/Seo";

const Archive = ({ allPosts: { edges }, preview }) => {
  return (
    <>
      <Seo
        title="News Archiv"
        description="Das News Archiv zu easyboarding, Karrieretipps und Job-Beschreibungen."
      />
      <Layout preview={preview}>
        <Container backgroundColor="#f5f5f7">
          <ContainerContentNarrow>
            <BlogContentSection>
              <h2>News Archiv</h2>
              <BlogContentGrid role="list" twoColumns>
                {edges?.length > 0 && (
                  <PostTiles posts={edges} size={TileSizes.m} />
                )}
              </BlogContentGrid>
            </BlogContentSection>
          </ContainerContentNarrow>
        </Container>
      </Layout>
    </>
  );
};

export default Archive;

export async function getStaticProps({ preview = false }) {
  const allPosts = await getAllPostsForHome(preview, false);
  return {
    props: { allPosts, preview },
    revalidate: 120,
  };
}
